import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { API_URL } from "../../../constants";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { useLocation, useParams } from "react-router-dom";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { useDispatch } from "react-redux";
import moment from "moment";

const InterviewStatusReports = () => {
  const { ReqId } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const passedState = location.state;

  useEffect(() => {
    dispatch(updateNavbarHeading(passedState ? passedState?.text == "Fulfilled"? "Openings - Fulfilled": passedState?.text: "Interview Status Report"))
  }, [passedState])

  const [interviewStatusReportData, setInterviewStatusReportData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const columns = {
    JobCode: { text: "Job Code", align: "start", visible: false },
    EmpName: { text: "Resource", align: "left", visible: true },
    ClientName: { text: "Client Name", align: "left", visible: true },
    JobName: { text: "Job Title ", align: "left", visible: true },
    OpeningDate: { text: "Opn. Date", align: "center", visible: true },
    InterviewDate: { text: "Int. Date", align: "center", visible: true },
    Cost: { text: "Billing Rate", align: "end",visible:true },
    // Rate: { text: "Billing Rate", align: "end", visible: true },
    Currency: { text: "Currency", align: "start", visible: true },
    ProjectDOJ: { text: "Project DOJ", align: "left", visible: true },
    Status: { text: "Status ", align: "left", visible: true },
    Remark: { text: "Remark", align: "left", visible: true },
    Role: { text: "Role ", align: "left", visible: false },
    SourceName: { text: "Source ", align: "left", visible: false },
    VendoreName: { text: "Vendor ", align: "left", visible: false },
    //ProjectDOJ: { text: "Project DOJ", align: "center", visible: true },
    Round: { text: "Round ", align: "left", visible: false },
    // Employees: { text: "Employee ID", align: "left" },
    Priority: { text: "Priority", align: "left", visible: false },
    ROMPOC: { text: "RMG POC", align: "left", visible: false },
    SubmissionDate: { text: "Submission Date", align: "left", visible: false },
  };

  const [loading, setLoading] = useState(true);
  const [statusOption, setStatusOption] = useState([]);
  const [clientNameOption, setClientNameOption] = useState([]);
  const [apiStatus, setApiStatus] = useState(undefined)

  useEffect(() => {
    fetchInterviewStatusAPi();
  }, []);

  const [originalData, setOriginalData] = useState([]);
  useEffect(() => {
    if (!originalData?.length) return;

    const queryParams = new URLSearchParams(location.search);
    const status = queryParams.get('Status');
    const fromDate = queryParams.get('FromDate');

    const filteredData = originalData.filter(item => {
      // Date comparison
      const fromCondition = fromDate
        ? moment(item.ProjectDOJ, "YYYY-MM-DD").isSameOrAfter(moment(fromDate), 'day')
        : true;

      // Status comparison (case-insensitive and trimmed)
      const statusCondition = status
        ? item.Status?.trim().toLowerCase() === status.trim().toLowerCase()
        : true;

      return fromCondition && statusCondition;
    });
    const reversedData = [...filteredData].reverse();
    setInterviewStatusReportData(reversedData);
  }, [location.search, originalData]);


  const fetchInterviewStatusAPi = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}customer-requirement-interview-status?P_FromDate=${"2022-01-01"}&P_ToDate=${moment(new Date()).format("YYYY-MM-DD")}&P_ClientID=${0}&searchString=${0}&P_ReqID=${ReqId || ""}&P_DOJFDate=${""}&P_DOJTDate=${""}`
      );
      setApiStatus(response?.status)
      if (response.status === 200) {
        const cleanedData = response?.data;
        setOriginalData(cleanedData.interviewstatus)
        setInterviewStatusReportData(cleanedData.interviewstatus);

        const statusOptions = cleanedData?.processstatus?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setStatusOption(statusOptions);
        const clientNameOptions = cleanedData?.clientname?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setClientNameOption(clientNameOptions);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch RMG Interview Status . Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching RMG Interview Status", error);
    }
  };




  const handleGetData = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}customer-requirement-interview-status?P_FromDate=${filterFormData.find((o) => o.label === "From Date")
          ? moment(filterFormData.find((o) => o.label === "From Date").value).format("YYYY-MM-DD")
          : ""
        }&P_ToDate=${filterFormData.find((o) => o.label === "To Date")
          ? moment(filterFormData.find((o) => o.label === "To Date").value).format("YYYY-MM-DD")
          : ""
        }&P_ClientID=${filterFormData.find((o) => o.label === "Client")
          ? filterFormData.find((o) => o.label === "Client").value
          : 0
        }&searchString=${filterFormData.find((o) => o.label === "Status")
          ? filterFormData.find((o) => o.label === "Status").value
          : 0
        }&P_ReqID=${""}
        &P_DOJFDate=${filterFormData.find((o) => o.label === "PDOJ From Date")
          ? moment(filterFormData.find((o) => o.label === "PDOJ From Date").value).format("YYYY-MM-DD")
          : ""
        }
        &P_DOJTDate=${filterFormData.find((o) => o.label === "PDOJ To Date")
          ? moment(filterFormData.find((o) => o.label === "PDOJ To Date").value).format("YYYY-MM-DD")
          : ""
        }`

      );
      setApiStatus(response?.status)
      if (response.status === 200) {
        const cleanedData = response?.data;
        setInterviewStatusReportData(cleanedData.interviewstatus);

        const statusOptions = cleanedData?.processstatus?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setStatusOption(statusOptions);
        const clientNameOptions = cleanedData?.clientname?.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setClientNameOption(clientNameOptions ||[]);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch RMG Interview Status . Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching RMG Interview Status", error);
    }
  };



  const formDatas = [
    { name: "From Date", type: "Date" },
    { name: "To Date", type: "Date" },
    { name: "Client", type: "Select", options: [...clientNameOption ||[]] },
    { name: "Status", type: "Select", options: [...statusOption||[]] },
    { name: "PDOJ From Date", type: "Date" },
    { name: "PDOJ To Date", type: "Date" },

  ];
  const [filterFormData, setFilterData] = useState([]);

  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        const updatedFormData = prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e.value !== undefined ? e.value : e }
            : item
        );
        return updatedFormData;
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [
          ...prevFormData,
          {
            label: name,
            value: e.value !== undefined ? e.value : e, // Assuming e is an event object
          },
        ];
      }
    });
  };


  const handleReset = () => {
    setFilterData([])
    fetchInterviewStatusAPi()
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={interviewStatusReportData}
              handleReset={handleReset}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isSorting={true}
              isFilterRequired={true}
              handleChange={handleChange}
              isRequiredStatus={true}
              isApiStatus={apiStatus}
              handleGetData={handleGetData}
              formDatas={formDatas}
              filterFormData={filterFormData}
              add
              more
              function
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default InterviewStatusReports;
